var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-switch',{on:{"input":_vm.onChange},model:{value:(_vm.orderStatus.attributes['is-visible-deliver']),callback:function ($$v) {_vm.$set(_vm.orderStatus.attributes, 'is-visible-deliver', $$v)},expression:"orderStatus.attributes['is-visible-deliver']"}})
}
var staticRenderFns = []

export { render, staticRenderFns }